export function dollars(value) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? `$${numericValue.toFixed(2)}` : "$-.--";
}
